<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard">
      <p-toast key="toastmsg"></p-toast>
        <div class="mainDivHeader">
          <div class="leftdiv">
            <h4>TDS Deduction List<span class="badge">{{totalRecords}}</span></h4>
          </div>
          <div class="rightDiv">
            <button class="exportBTn" pTooltip="XLS" tooltipPosition="bottom" (click)="exportExcel()"> <span><img
                  src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
              Export</button> 
          </div>
        </div>  
        <div class="mainDivBody">
            <div class="date-filterDiv">
              <ul class="filtersList">
                <li>
                    <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                        optionLabel="label"></p-dropdown>
                </li>
                <li>
                    <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                    class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="FROM: dd / mm / yy"></p-calendar>
                </li>
                <li>
                    <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                    class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="To: dd / mm / yy"></p-calendar>
                </li>
                <li>
                    <button (click)="tdsList(lastTableLazyLoadEvent)" class="searchFilterBtn">
                      <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                    </button>
                </li>
                <li>
                    <button (click)="clear()" class="clearFilterBtn">
                      <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                    <span>Clear All</span>
                    </button>
                </li>
              </ul>
          </div>
          <div class="maintableDiv">
            <div class="tableParanet">
              <p-table class="expandable" #dt [value]="walletlist" [autoLayout]="true" [paginator]="true" [rows]="10"
                [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both" (onLazyLoad)="tdsList($event)"
                [totalRecords]="totalRecords" [loading]="loading" [rowsPerPageOptions]="paginationOption"
                styleClass="p-datatable-gridlines p-datatable-striped">
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th pfrozencolumn="" class="p-element text-nowrap tdsSectionTD" pSortableColumn="tdsSection">
                      <div class="p-d-flex p-jc-between p-ai-center"> TDS Section <p-sortIcon field="deductee"></p-sortIcon>
                      </div>
                    </th>

                    <th pfrozencolumn="" class="p-element text-nowrap panTD" pSortableColumn="pan">
                      <div class="p-d-flex p-jc-between p-ai-center"> Pan Number <p-sortIcon field="pan"></p-sortIcon>
                      </div>
                    </th>

                    <th pfrozencolumn="" class="p-element text-nowrap deducteeTD" pSortableColumn="deductee">
                      <div class="p-d-flex p-jc-between p-ai-center"> Name of Deductee <p-sortIcon field="deductee"></p-sortIcon>
                      </div>
                    </th>

                    <th pSortableColumn="created_at" class="withdrawDateTD">
                      <div class="p-d-flex p-jc-between p-ai-center"> Withdraw Amount Date <p-sortIcon field="created_at"></p-sortIcon>
                      </div>
                    </th>

                    <th class="withdrawIdX" pSortableColumn="withdrawIdX">
                      <div class="p-d-flex p-jc-between p-ai-center"> Withdraw ID <p-sortIcon field="transferAmount"></p-sortIcon>
                      </div>
                    </th>

                    <th pSortableColumn="created_at" class="creditDateTD">
                      <div class="p-d-flex p-jc-between p-ai-center"> Amount Paid/Credited Date <p-sortIcon field="tds"></p-sortIcon>
                      </div>
                    </th>
                    <th  pSortableColumn="tdsRate" class="tdsRateTD">
                      <div class="p-d-flex p-jc-between p-ai-center">TDS Deduction Rate <p-sortIcon
                          field="totalCreditedAmount"></p-sortIcon>
                      </div>
                    </th>
                    <th pSortableColumn="tdsDeductedAmount" class="paymentreditTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                      <div class="p-d-flex p-jc-between p-ai-center"> Amount of Payment/Credit <p-sortIcon field="status"></p-sortIcon>
                      </div>
                    </th>
                    <th pSortableColumn="tdsAmount" class="tdsAmountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                      <div class="p-d-flex p-jc-between p-ai-center"> TDS Deduction Amount <p-sortIcon field="status"></p-sortIcon>
                      </div>
                    </th>                    
                    <th class="sorting_disabled text-nowrap p-element p-frozen-column actionTD" rowspan="1" colspan="1">
                      Action 
                    </th>
                  </tr>
                  <tr>
                      <th [ngSwitch]="tdsSection" pfrozencolumn="" class="p-element  text-nowrap tdsSectionTD">
                        <input pInputText type="text"
                          (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tdsSection', 'contains')"
                          [value]=" dt.filters['tdsSection'] ? dt.filters['tdsSection'].value : ''" />
                      </th>
                      <th [ngSwitch]="pan" class="p-element  text-nowrap panTD">
                        <input pInputText type="text"
                          (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'pan', 'contains')"
                          [value]=" dt.filters['pan'] ? dt.filters['pan'].value : ''" />
                      </th>
                      <th [ngSwitch]="deductee" class="p-element  text-nowrap deducteeTD">
                        <input pInputText type="text"
                          (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'deductee', 'contains')"
                          [value]=" dt.filters['deductee'] ? dt.filters['deductee'].value : ''" />
                      </th>
                    <th [ngSwitch]="created_at" class="withdrawDateTD">
                      <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050" (onSelect)="setDownloadFlag(); dt.filter($event,'withdraw_date', 'dateIs')" [(ngModel)]="calvalue"
                            class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                    </th>
                    <th [ngSwitch]="withdrawId"  class="p-element   text-nowrap withdrawIdX">
                      <input pInputText type="text" (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'withdrawId', 'contains')" [value]=" dt.filters['withdrawId'] ? dt.filters['withdrawId'].value : '' " />
                    </th>
                    <th [ngSwitch]="created_at" class="creditDateTD">   
                      <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050" (onSelect)="setDownloadFlag(); dt.filter($event,'credited_date', 'dateIs')" [(ngModel)]="ucalvalue"
                            class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>                 
                    </th>
                    <th [ngSwitch]="tdsRate"  class="p-element   text-nowrap tdsRateTD">
                      <input pInputText type="text" (keyup.enter)="
                            setDownloadFlag();
                            dt.filter($event.target.value, 'tdsRate', 'contains') " [value]=" dt.filters['tdsRate']
                              ? dt.filters['tdsRate'].value : '' " />
                    </th>
                    <th [ngSwitch]="tdsDeductedAmount" class="paymentreditTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                      <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'tdsDeductedAmount', 'contains') "
                      [value]=" dt.filters['tdsDeductedAmount']
                            ? dt.filters['tdsDeductedAmount'].value: '' " />
                    </th>
                    <th [ngSwitch]="tdsAmount" class="tdsAmountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                      <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'tdsAmount', 'contains') "
                      [value]=" dt.filters['tdsAmount']
                            ? dt.filters['tdsAmount'].value: '' " />
                    </th>
                    <th class="text-nowrap p-element p-frozen-column actionTD" style="justify-content: center;">
                        <div class="buttonColumn">
                            <button class="addBTn" (click)="addColumns()"
                                [ngClass]="hide ? 'show-column ' : 'hide-column'">
                                + Show Column
                            </button>
                            <button class="removeBTn" (click)="removeColumns()"
                                [ngClass]="hide ? 'hide-column' : 'show-column '">
                                - Hide Column
                            </button>
                        </div>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-walletlist>
                  <tr class="p-selectable-row">
                    <td pfrozencolumn="" class="p-element text-nowrap tdsSectionTD">
                      {{ walletlist.tdsSection||"" }}
                    </td>

                    <td class="p-element text-nowrap panTD">
                    {{ walletlist.pan||"" }}
                  </td>
                    <td  class="p-element text-nowrap deducteeTD">
                      {{ walletlist.deductee }}
                    </td>
                    <td class="withdrawDateTD">
                      {{ walletlist.created_at | date : "dd/MM/yyyy" }}
                    </td>
                    <td class="withdrawIdX">
                      {{  walletlist.withdrawId}}
                    </td>
                    <td class="creditDateTD">
                      {{ walletlist.created_at | date : "dd/MM/yyyy" }}
                    </td>
                    <td class="tdsRateTD">
                      {{ walletlist.tdsRate }}
                    </td>
                    <td class="paymentreditTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                      {{ walletlist.tdsDeductedAmount }}
                    </td>
                    <td class="tdsAmountTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                      {{ walletlist.tdsAmount }}
                    </td>
                    <td class="text-nowrap p-element p-frozen-column actionTD"></td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="9">TDS deduction list not found.</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>  
          </div>    
        </div>
    </div>
  </div>
